import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.js";
import { AppErrorBoundary } from "./components/layout/AppErrorBoundary.js";
import { initSentry } from "./lib/sentry.js";
import "./index.css";

// Wire up browser error reporting before we mount. No-op (returns false)
// when VITE_SENTRY_DSN wasn't set at build time — see lib/sentry.ts.
initSentry();

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Missing #root");

// A second boundary around everything. App's own sits inside its
// providers, so a crash in one of them, or in the theme picker or the
// confirm pop-up that render beside it, would otherwise blank the page.
// The fallback reads no context, so it works out here.
ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>,
);
